export const ConsumerPostSubmissionDeclinedViewUat = {
  title: 'workflow.postSubmissionDeclined.title',
  contactInfo: 'workflow.postSubmissionDeclined.contactInfo',
}
